import React from 'react'

import { ANIMATED_LAYOUT } from './constants'
import { motion } from 'motion/react'
import { HeaderControls } from './headerControls'
import { HeaderTitle } from './headerTitle'
import type { AgentHeaderVisualState, ControlsConfig, IconRenderFunction } from './types'
import { balanceControls } from './utils'
import { useCompactLayout } from '../compactLayout'
import { useLayoutTransition } from '../animation/hooks/useLayoutTransition'

export type AgentHeaderProps = {
  title: string
  renderIcon: IconRenderFunction
  state?: AgentHeaderVisualState
  controls?: Partial<ControlsConfig>
}

export const AgentHeader: React.FC<AgentHeaderProps> = ({
  title,
  renderIcon,
  state,
  controls = {},
}) => {
  const transition = useLayoutTransition()

  const compactLayoutState = useCompactLayout()

  const isExpanded = state !== undefined ? state === 'expanded' : compactLayoutState === 'spacious'
  const balancedControls = balanceControls(controls)
  const hasLeftControls = !!controls?.left?.length

  return (
    <motion.header transition={transition} style={ANIMATED_LAYOUT.header(isExpanded)}>
      <motion.div
        layout={'position'}
        transition={transition}
        style={ANIMATED_LAYOUT.headerLayout(isExpanded)}
      >
        {hasLeftControls && <HeaderControls type="left" controls={balancedControls.left} />}
        <HeaderTitle title={title} renderIcon={renderIcon} isExpanded={isExpanded} />
        <HeaderControls type="right" controls={balancedControls.right} />
      </motion.div>
    </motion.header>
  )
}
